module.exports = __webpack_public_path__ + "media/post-listing-block-6-image-step3.89d43cc1.webp";